
export const subjectIds = [
  // 30分钟版入学测评
  {
    1: [293, 291, 292, 290],
    2: [291, 293, 290, 292],
  },
  // 完整版入学测评
  {
    1: [289, 287, 293, 291, 292, 290],
    2: [289, 287, 291, 293, 290, 292],
    56: [290, 291, 292, 293], // 国高测评
  },
  // 智适应入学测评
  {
    2: [287],
  },
];

export const subjectData = [
  // 30分钟版入学测评
  {
    1: [
      ['阅读', '题目数量 15道', '建议用时 10分钟'],
      ['听力', '题目数量 15道', '建议用时 10分钟'],
      ['口语', '题目数量 1道', '建议用时 2分钟'],
      ['写作', '题目数量 3道', '建议用时 8分钟'],
    ],
    2: [
      ['听力', '题目数量 10道', '建议用时 7分钟'],
      ['阅读', '题目数量 9道', '建议用时 10分钟'],
      ['写作', '题目数量 4道', '建议用时 8分钟'],
      ['口语', '题目数量 9道', '建议用时 5分钟'],
    ],
  },
  // 完整版入学测评
  {
    1: [
      ['词汇', '题目数量 30道', '建议用时 10分钟'],
      ['语法', '题目数量 80道', '建议用时 30分钟'],
      ['阅读', '题目数量 30道', '建议用时 40分钟'],
      ['听力', '题目数量 40道', '建议用时 40分钟'],
      ['口语', '题目数量 9道', '建议用时 15分钟'],
      ['写作', '题目数量 15道', '建议用时 40分钟'],
    ],
    2: [
      ['词汇', '题目数量 30道', '建议用时 10分钟'],
      ['语法', '题目数量 80道', '建议用时 30分钟'],
      ['听力', '题目数量 33道', '建议用时 40分钟'],
      ['阅读', '题目数量 18道', '建议用时 40分钟'],
      ['写作', '题目数量 10道', '建议用时 40分钟'],
      ['口语', '题目数量 22道', '建议用时 15分钟'],
    ],
    56: [
      ['单项选择', '题目数量 20道', '建议用时 10分钟'],
      ['完形填空', '题目数量 20道', '建议用时 15分钟'],
      ['阅读理解', '题目数量 13道', '建议用时 15分钟'],
      ['数学', '题目数量 25道', '建议用时 15分钟'],
    ],
  },
  // 智适应入学测评
  {
    2: [
      ['综合', '题目数量 23道', '建议用时 20分钟'],
    ],
  },
]



// WEBPACK FOOTER //
// ./src/components/entrance/comment.js